export default __webpack_public_path__ + "static/media/HUD-Effects-HUD Artifacts.99536b1a.jpg";